"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.root = exports.expandButton = exports.rowStyle = void 0;

var _reactEmotion = require("react-emotion");

var _themeConfig = _interopRequireDefault(require("@lyearn-team/theme-config"));

var rowStyle = function rowStyle(theme, isClickable, isHovered) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("border-bottom:1px solid ", theme.color.dark.venus, ";transition:background-color 0.25s;", isClickable && "\n    cursor: pointer;\n    &:hover {\n      background-color: ".concat(theme.color.dark.mars, ";\n    }\n    \n    ").concat(isHovered && "\n      background-color: ".concat(theme.color.dark.mars, ";\n    "), "\n  "), ";")
  );
};

exports.rowStyle = rowStyle;
var expandButton =
/*#__PURE__*/
(0, _reactEmotion.css)("margin-right:6px;color:", _themeConfig.default.color.dark.sapphire, ";fill:", _themeConfig.default.color.dark.sapphire, ";");
exports.expandButton = expandButton;

var root = function root(theme) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("display:inline-block;width:16px;line-height:0;cursor:pointer;margin-right:10px;> div{display:inline-block;width:5px;height:5px;margin:1.5px;border-radius:50%;background-color:#929fae;}",
    /*#__PURE__*/
    (0, _reactEmotion.css)("&:hover{> div{background-color:", theme.color.dark.mars, ";}}"))
  );
};

exports.root = root;